<script lang="ts">
  // Hand-rolled autocomplete (no new dependency): free text is always
  // allowed (a technician can type a unit that doesn't exist yet), but
  // existing units for the selected company are suggested first so spelling
  // stays consistent across issues on the same lot.
  let {
    value = $bindable(''),
    suggestions = [],
    placeholder = 'e.g. Standard Room — First Lot',
    id
  }: {
    value: string;
    suggestions: string[];
    placeholder?: string;
    id?: string;
  } = $props();

  let open = $state(false);

  const filtered = $derived(
    suggestions.filter((s) => s.toLowerCase().includes(value.trim().toLowerCase())).slice(0, 8)
  );

  function pick(name: string) {
    value = name;
    open = false;
  }
</script>

<div class="relative">
  <input
    {id}
    class="input"
    bind:value
    {placeholder}
    autocomplete="off"
    onfocus={() => (open = true)}
    onblur={() => setTimeout(() => (open = false), 120)}
  />
  {#if open && filtered.length > 0}
    <div
      class="absolute left-0 right-0 top-full z-30 mt-1.5 rounded-[11px] border border-toyama-cloudy-gray bg-white p-1.5 shadow-[var(--tym-shadow-3)]"
    >
      <div class="px-2.5 pb-0.5 pt-1 text-[10px] font-semibold uppercase tracking-[.08em] text-dark-gray">
        Existing units &middot; keep spelling consistent
      </div>
      {#each filtered as s (s)}
        <!-- svelte-ignore a11y_mouse_events_have_key_events -->
        <button
          type="button"
          class="flex w-full items-center gap-2 rounded-lg px-2.5 py-2 text-left hover:bg-toyama-light-carbon"
          onmousedown={() => pick(s)}
        >
          <span class="flex-1 text-[13px] font-medium text-navy">{s}</span>
        </button>
      {/each}
    </div>
  {/if}
</div>
